import { BaseController } from 'controllers/BaseController'
import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import {
  DeprovisionSCSNRequest,
  ManagementPartyDto,
  ProvisionSCSNRequest,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'

interface ISCSNManamgenetAPI {
  provisionSCSN(req: ProvisionSCSNRequest): Promise<ManagementPartyDto>
  deProvisionSCSN(req: DeprovisionSCSNRequest): Promise<ManagementPartyDto>
}

class SCSNManagementAPI extends InternalAPI implements ISCSNManamgenetAPI {
  constructor(onRequestChanged: OnRequestChangeCallback) {
    super('/api/system/partymanagement/scsn', onRequestChanged)
  }

  public async provisionSCSN(
    req: ProvisionSCSNRequest,
  ): Promise<ManagementPartyDto> {
    return this.PostAsync<ManagementPartyDto>({
      id: 'SCSNManagementAPI-ProvisionSCSN',
      relativePath: '/provision',
      data: req,
    })
  }

  public async deProvisionSCSN(
    req: DeprovisionSCSNRequest,
  ): Promise<ManagementPartyDto> {
    return this.PostAsync<ManagementPartyDto>({
      id: 'SCSNManagementAPI-DeProvisionSCSN',
      relativePath: '/deprovision',
      data: req,
    })
  }
}

export class SCSNManagementController extends BaseController<ISCSNManamgenetAPI> {
  constructor() {
    super((onRequestChanged) => new SCSNManagementAPI(onRequestChanged))
  }

  public async provisionSCSN(
    req: ProvisionSCSNRequest,
  ): Promise<ManagementPartyDto> {
    try {
      return await this.api.provisionSCSN(req)
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public async deProvisionSCSN(
    req: DeprovisionSCSNRequest,
  ): Promise<ManagementPartyDto> {
    try {
      return await this.api.deProvisionSCSN(req)
    } catch (err) {
      throw this.HandleError(err)
    }
  }
}
